import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { productColorsWithImage } from '../services/Product-service';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function ShopByColor({ showrangbhoomi, sectionTitle }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [colors, setColors] = useState([]);

    const CustomPrevArrow = ({ className, style, onClick, isDisabled }) => (
        <button
            className={className}
            style={{
                ...style,
                display: isDisabled ? 'none' : 'block',
            }}
            onClick={!isDisabled ? onClick : null}
        />
    );

    const CustomNextArrow = ({ className, style, onClick }) => (
        <button className={className} style={{ ...style }} onClick={onClick} />
    );

    useEffect(() => {
        if (!showrangbhoomi) return;

        productColorsWithImage()
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setColors(
                    list.filter(
                        (item) =>
                            item?.color_id &&
                            item?.product_thumbail &&
                            item?.color_name
                    )
                );
            })
            .catch((error) => {
                console.error('Error fetching product colors:', error);
            });
    }, [showrangbhoomi]);

    const totalItems = colors.length;
    const desktopSlidesToShow = 5;
    const tabletSlidesToShow = 2;
    const mobileSlidesToShow = 2;

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        prevArrow: <CustomPrevArrow isDisabled={currentSlide === 0} />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(tabletSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > tabletSlidesToShow ? tabletSlidesToShow : 1,
                    initialSlide: 0,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(mobileSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > mobileSlidesToShow ? mobileSlidesToShow : 1,
                    arrows: false,
                    initialSlide: 0,
                },
            },
        ],
    };

    if (!showrangbhoomi || totalItems === 0) return null;

    return (
        <div>
            <div className="App">
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer rangbhoomi">
                        <div className="layout row justify-space-between align-center text-left SectionTitle">
                            <h1 className="m-t-0 m-b-0 demi-bold w-auto">{sectionTitle || 'RANGBHOOMI'}</h1>
                        </div>
                        <div className="layout">
                            <div className="flex left-align-slick xs12">
                                <Slider {...settings}>
                                    {colors.map((data) => (
                                        <div className="item sjl" key={data.color_id}>
                                            <div className="CarouselSection category">
                                                <div className="prel Gutter">
                                                    <Link to={`/category/?campaign=2&color_ids=${data.color_id}`}>
                                                        <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                            <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                                <img
                                                                    src={data.product_thumbail}
                                                                    alt={data.color_name}
                                                                    className="img-resp DynamicHeightLoaderImage"
                                                                    style={{ padding: '0px' }}
                                                                />
                                                            </div>
                                                            <div className="animated-bg-placeholder"></div>
                                                        </div>
                                                        <div className="ImageTextDetail ProductImageTextDetail">
                                                            <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold">
                                                                {data.color_name}
                                                            </label>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShopByColor;
